var map = {
	"./back-from.png": 38413,
	"./begins.png": 57753,
	"./blood.png": 47391,
	"./blue_bang.png": 31354,
	"./combat.png": 44239,
	"./first.png": 62885,
	"./frozen.png": 91473,
	"./gen_bg.png": 19439,
	"./hit.png": 94928,
	"./kill.png": 81695,
	"./multi.png": 92176,
	"./on-fire.png": 14655,
	"./one.png": 90883,
	"./orange_bang.png": 44420,
	"./shot.png": 33279,
	"./spectacular.png": 60986,
	"./stuff-is.png": 65992,
	"./the-brink.png": 41053,
	"./tutorial.png": 873
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6557;